import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import ListGroup from 'react-bootstrap/ListGroup';
import Form from 'react-bootstrap/Form';
import { formatDate } from '../../common/utils';
import Sources from '../../components/Reports/Sources';
import GreatnessTracker from '../../components/Reports/CORE/GreatnessTracker';
import LeadTracker from '../../components/Reports/CORE/LeadTracker';
import Conversions from '../../components/Reports/Conversions';
import LeaderboardIndividual from '../../components/Reports/Leaderboards/individual';
import LeaderboardTeam from '../../components/Reports/Leaderboards/team';
import LeaderboardCompany from '../../components/Reports/Leaderboards/company';
import Birthdays from '../../components/Reports/Birthdays';
import ReportsSidebar from './sidebar';
import FunnelBarChart from '../../components/Reports/Charts/Bar/funnel';


const Reports = ( { aid, purpose, sources } ) => {
    const [ reportType, setReportType ] = useState( 'sources' );
    const [ startDate, setStartDate ] = useState();
    const [ endDate, setEndDate ] = useState();
    const [ loanPurpose, setLoanPurpose ] = useState( '*' );
    const [ leadSource, setLeadSource ] = useState( '*' );
    const [ plist, setPList ] = useState( [] );
    const [ sourceList, setSourceList ] = useState( [] );
    const [ reportComponent, setReportComponent ] = useState();

    const renderReport = () => {
        const C = reportComponent;
        return ( C ) ? <C start={startDate} end={endDate} purpose={loanPurpose} source={leadSource} /> : null;
    }

    useEffect( () => {
        if ( purpose ) {
            setPList( purpose );
        }
    }, [ purpose ] );

    useEffect( () => {
        if ( sources ) {
            const list = [ ...sources ];
            list.sort();
            setSourceList( list );
        }
    }, [ sources ] );

    useEffect( () => {
        const options = {
            sources: Sources,
            conversions: Conversions,
            lbindividual: LeaderboardIndividual,
            lbteam: LeaderboardTeam,
            lbcompany: LeaderboardCompany,
            gt: GreatnessTracker,
            lt: LeadTracker,
            bday: Birthdays,
            funnel: FunnelBarChart
        };

        setReportComponent( options[reportType] );
    }, [ reportType ] );

    useEffect(() => {
        document.title = 'Third Floor - Reports';
        const today = new Date();
        setStartDate( today.getFullYear() + '-01-01' );
        setEndDate( formatDate( today ) );
    }, [] );

    return (
        <Container fluid className='p-0 tf-body-container'>
            <Row style={ { height: 'calc(100% - 15px)' } }>
                <ReportsSidebar setReportType={setReportType} />
                <Col className='ps-0' md={10} style={ { height: '100%' } }>
                    <Row className='tf-section-container ms-2'>
                        <Col>
                            <Row>
                                <Col>
                                    Report Filters
                                </Col>
                            </Row>
                            <Row>
                                <Col xs='auto'>
                                    <Row>
                                        <Col>Start Date</Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <Form.Control type='date' value={ startDate } onChange={ ( e ) => setStartDate( e.target.value ) } />    
                                        </Col>
                                    </Row>
                                </Col>
                                <Col xs='auto'>
                                    <Row>
                                        <Col>End Date</Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <Form.Control type='date' value={ endDate } onChange={ ( e ) => setEndDate( e.target.value ) } />    
                                        </Col>
                                    </Row>
                                </Col>
                                <Col xs='auto'>
                                    <Row>
                                        <Col>Loan Purpose</Col>
                                    </Row>
                                    <Row>
                                        <Col xs='auto' className='me-1'>
                                            <Form.Select size='sm' value={loanPurpose} onChange={ ( e ) => setLoanPurpose( e.target.value ) }>
                                                <option value='*'>All</option>
                                                {
                                                    plist.map( ( p, idx ) => <option key={`purp-${idx}`} value={p.value}>{p.label}</option> )
                                                }
                                            </Form.Select>
                                        </Col>
                                    </Row>
                                </Col>
                                {
                                    [ 'conversions' ].includes( reportType ) ? (
                                        <Col xs='auto'>
                                            <Row>
                                                <Col>Lead Source</Col>
                                            </Row>
                                            <Row>
                                                <Col xs='auto' className='me-1'>
                                                    <Form.Select size='sm' value={leadSource} onChange={ ( e ) => setLeadSource( e.target.value ) }>
                                                        <option value='*'>All</option>
                                                        {
                                                            sourceList.map( ( s, idx ) => <option key={`source-${idx}`} value={s.value}>{s.label}</option> )
                                                        }
                                                    </Form.Select>
                                                </Col>
                                            </Row>
                                        </Col>
                                    ) : (
                                        null
                                    )
                                }
                            </Row>
                        </Col>
                    </Row>
                    <Row className='tf-section-container ms-2'>
                        <Col>
                        {
                            renderReport()
                        }
                        </Col>
                    </Row>
                </Col>
            </Row>
        </Container>
    )
}

const mapProps = ( state ) =>( {
    aid: state.user.aid,
    purpose: state.user.meta.global.picklist.purpose,
    sources: state.user.meta.global.picklist.source
} );

const mapDispatch = ( dispatch ) => ( {
} );

export default connect( mapProps, mapDispatch )( Reports );